// source: pbtypes/vehicle/return_manager/stored_waypoint.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var pbtypes_vehicle_motion_manager_frames_pb = require('../../../pbtypes/vehicle/motion_manager/frames_pb.js');
goog.object.extend(proto, pbtypes_vehicle_motion_manager_frames_pb);
var pbtypes_vehicle_return_manager_waypoint_pb = require('../../../pbtypes/vehicle/return_manager/waypoint_pb.js');
goog.object.extend(proto, pbtypes_vehicle_return_manager_waypoint_pb);
var pbtypes_gen_uuid_util_uuid_pb = require('../../../pbtypes/gen/uuid_util/uuid_pb.js');
goog.object.extend(proto, pbtypes_gen_uuid_util_uuid_pb);
goog.exportSymbol('proto.return_manager.StoredWaypointKeys', null, global);
goog.exportSymbol('proto.return_manager.StoredWaypointKeys.Enum', null, global);
goog.exportSymbol('proto.return_manager.StoredWaypointPb', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.return_manager.StoredWaypointKeys = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.return_manager.StoredWaypointKeys, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.return_manager.StoredWaypointKeys.displayName = 'proto.return_manager.StoredWaypointKeys';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.return_manager.StoredWaypointPb = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.return_manager.StoredWaypointPb, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.return_manager.StoredWaypointPb.displayName = 'proto.return_manager.StoredWaypointPb';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.return_manager.StoredWaypointKeys.prototype.toObject = function(opt_includeInstance) {
  return proto.return_manager.StoredWaypointKeys.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.return_manager.StoredWaypointKeys} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.return_manager.StoredWaypointKeys.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.return_manager.StoredWaypointKeys}
 */
proto.return_manager.StoredWaypointKeys.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.return_manager.StoredWaypointKeys;
  return proto.return_manager.StoredWaypointKeys.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.return_manager.StoredWaypointKeys} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.return_manager.StoredWaypointKeys}
 */
proto.return_manager.StoredWaypointKeys.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.return_manager.StoredWaypointKeys.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.return_manager.StoredWaypointKeys.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.return_manager.StoredWaypointKeys} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.return_manager.StoredWaypointKeys.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.return_manager.StoredWaypointKeys.Enum = {
  INVALID: 0,
  TAKEOFF: 1,
  HOME: 2,
  DOCK: 3,
  SAFE_LANDING: 4,
  CONTROLLER: 5,
  EXTERNAL_RADIO: 6
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.return_manager.StoredWaypointPb.prototype.toObject = function(opt_includeInstance) {
  return proto.return_manager.StoredWaypointPb.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.return_manager.StoredWaypointPb} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.return_manager.StoredWaypointPb.toObject = function(includeInstance, msg) {
  var f, obj = {
waypointInNav: (f = msg.getWaypointInNav()) && pbtypes_vehicle_return_manager_waypoint_pb.Waypoint.toObject(includeInstance, f),
waypointInGps: (f = msg.getWaypointInGps()) && pbtypes_vehicle_return_manager_waypoint_pb.Waypoint.toObject(includeInstance, f),
waypointInGlobalGraph: (f = msg.getWaypointInGlobalGraph()) && pbtypes_vehicle_return_manager_waypoint_pb.Waypoint.toObject(includeInstance, f),
waypointZInBaro: (f = msg.getWaypointZInBaro()) && pbtypes_vehicle_return_manager_waypoint_pb.WaypointZ.toObject(includeInstance, f),
id: (f = msg.getId()) && pbtypes_gen_uuid_util_uuid_pb.Uuid.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.return_manager.StoredWaypointPb}
 */
proto.return_manager.StoredWaypointPb.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.return_manager.StoredWaypointPb;
  return proto.return_manager.StoredWaypointPb.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.return_manager.StoredWaypointPb} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.return_manager.StoredWaypointPb}
 */
proto.return_manager.StoredWaypointPb.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new pbtypes_vehicle_return_manager_waypoint_pb.Waypoint;
      reader.readMessage(value,pbtypes_vehicle_return_manager_waypoint_pb.Waypoint.deserializeBinaryFromReader);
      msg.setWaypointInNav(value);
      break;
    case 2:
      var value = new pbtypes_vehicle_return_manager_waypoint_pb.Waypoint;
      reader.readMessage(value,pbtypes_vehicle_return_manager_waypoint_pb.Waypoint.deserializeBinaryFromReader);
      msg.setWaypointInGps(value);
      break;
    case 3:
      var value = new pbtypes_vehicle_return_manager_waypoint_pb.Waypoint;
      reader.readMessage(value,pbtypes_vehicle_return_manager_waypoint_pb.Waypoint.deserializeBinaryFromReader);
      msg.setWaypointInGlobalGraph(value);
      break;
    case 4:
      var value = new pbtypes_vehicle_return_manager_waypoint_pb.WaypointZ;
      reader.readMessage(value,pbtypes_vehicle_return_manager_waypoint_pb.WaypointZ.deserializeBinaryFromReader);
      msg.setWaypointZInBaro(value);
      break;
    case 5:
      var value = new pbtypes_gen_uuid_util_uuid_pb.Uuid;
      reader.readMessage(value,pbtypes_gen_uuid_util_uuid_pb.Uuid.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.return_manager.StoredWaypointPb.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.return_manager.StoredWaypointPb.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.return_manager.StoredWaypointPb} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.return_manager.StoredWaypointPb.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWaypointInNav();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      pbtypes_vehicle_return_manager_waypoint_pb.Waypoint.serializeBinaryToWriter
    );
  }
  f = message.getWaypointInGps();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      pbtypes_vehicle_return_manager_waypoint_pb.Waypoint.serializeBinaryToWriter
    );
  }
  f = message.getWaypointInGlobalGraph();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      pbtypes_vehicle_return_manager_waypoint_pb.Waypoint.serializeBinaryToWriter
    );
  }
  f = message.getWaypointZInBaro();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      pbtypes_vehicle_return_manager_waypoint_pb.WaypointZ.serializeBinaryToWriter
    );
  }
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      pbtypes_gen_uuid_util_uuid_pb.Uuid.serializeBinaryToWriter
    );
  }
};


/**
 * optional Waypoint waypoint_in_nav = 1;
 * @return {?proto.return_manager.Waypoint}
 */
proto.return_manager.StoredWaypointPb.prototype.getWaypointInNav = function() {
  return /** @type{?proto.return_manager.Waypoint} */ (
    jspb.Message.getWrapperField(this, pbtypes_vehicle_return_manager_waypoint_pb.Waypoint, 1));
};


/**
 * @param {?proto.return_manager.Waypoint|undefined} value
 * @return {!proto.return_manager.StoredWaypointPb} returns this
*/
proto.return_manager.StoredWaypointPb.prototype.setWaypointInNav = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.return_manager.StoredWaypointPb} returns this
 */
proto.return_manager.StoredWaypointPb.prototype.clearWaypointInNav = function() {
  return this.setWaypointInNav(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.return_manager.StoredWaypointPb.prototype.hasWaypointInNav = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Waypoint waypoint_in_gps = 2;
 * @return {?proto.return_manager.Waypoint}
 */
proto.return_manager.StoredWaypointPb.prototype.getWaypointInGps = function() {
  return /** @type{?proto.return_manager.Waypoint} */ (
    jspb.Message.getWrapperField(this, pbtypes_vehicle_return_manager_waypoint_pb.Waypoint, 2));
};


/**
 * @param {?proto.return_manager.Waypoint|undefined} value
 * @return {!proto.return_manager.StoredWaypointPb} returns this
*/
proto.return_manager.StoredWaypointPb.prototype.setWaypointInGps = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.return_manager.StoredWaypointPb} returns this
 */
proto.return_manager.StoredWaypointPb.prototype.clearWaypointInGps = function() {
  return this.setWaypointInGps(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.return_manager.StoredWaypointPb.prototype.hasWaypointInGps = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional Waypoint waypoint_in_global_graph = 3;
 * @return {?proto.return_manager.Waypoint}
 */
proto.return_manager.StoredWaypointPb.prototype.getWaypointInGlobalGraph = function() {
  return /** @type{?proto.return_manager.Waypoint} */ (
    jspb.Message.getWrapperField(this, pbtypes_vehicle_return_manager_waypoint_pb.Waypoint, 3));
};


/**
 * @param {?proto.return_manager.Waypoint|undefined} value
 * @return {!proto.return_manager.StoredWaypointPb} returns this
*/
proto.return_manager.StoredWaypointPb.prototype.setWaypointInGlobalGraph = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.return_manager.StoredWaypointPb} returns this
 */
proto.return_manager.StoredWaypointPb.prototype.clearWaypointInGlobalGraph = function() {
  return this.setWaypointInGlobalGraph(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.return_manager.StoredWaypointPb.prototype.hasWaypointInGlobalGraph = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional WaypointZ waypoint_z_in_baro = 4;
 * @return {?proto.return_manager.WaypointZ}
 */
proto.return_manager.StoredWaypointPb.prototype.getWaypointZInBaro = function() {
  return /** @type{?proto.return_manager.WaypointZ} */ (
    jspb.Message.getWrapperField(this, pbtypes_vehicle_return_manager_waypoint_pb.WaypointZ, 4));
};


/**
 * @param {?proto.return_manager.WaypointZ|undefined} value
 * @return {!proto.return_manager.StoredWaypointPb} returns this
*/
proto.return_manager.StoredWaypointPb.prototype.setWaypointZInBaro = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.return_manager.StoredWaypointPb} returns this
 */
proto.return_manager.StoredWaypointPb.prototype.clearWaypointZInBaro = function() {
  return this.setWaypointZInBaro(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.return_manager.StoredWaypointPb.prototype.hasWaypointZInBaro = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional uuid_util.Uuid id = 5;
 * @return {?proto.uuid_util.Uuid}
 */
proto.return_manager.StoredWaypointPb.prototype.getId = function() {
  return /** @type{?proto.uuid_util.Uuid} */ (
    jspb.Message.getWrapperField(this, pbtypes_gen_uuid_util_uuid_pb.Uuid, 5));
};


/**
 * @param {?proto.uuid_util.Uuid|undefined} value
 * @return {!proto.return_manager.StoredWaypointPb} returns this
*/
proto.return_manager.StoredWaypointPb.prototype.setId = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.return_manager.StoredWaypointPb} returns this
 */
proto.return_manager.StoredWaypointPb.prototype.clearId = function() {
  return this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.return_manager.StoredWaypointPb.prototype.hasId = function() {
  return jspb.Message.getField(this, 5) != null;
};


goog.object.extend(exports, proto.return_manager);
